// src/preventZoom.js

const preventZoom = () => {
  document.addEventListener('gesturestart', function (e) {
    e.preventDefault();
  });
};

export default preventZoom;